// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3Xs8H","title":"BackImages_title__2yTIl","images":"BackImages_images__2rVXj"};